import { Web } from 'sip.js';

// This host intermittently loses the authenticated INVITE immediately after
// the 407 ACK. Space that retry only; keep the normal SIP digest exchange.
export default class RelayVoiceTransport extends Web.Transport {
  send(message) {
    if (
      message.startsWith('INVITE ') &&
      /\r\nProxy-Authorization:/i.test(message)
    ) {
      return new Promise(resolve => {
        setTimeout(resolve, 100);
      }).then(() => super.send(message));
    }
    return super.send(message);
  }
}
